import {
  OrganizationSwitcher,
  SignedIn,
  SignedOut,
  SignInButton,
  UserButton,
  useAuth,
} from "@clerk/react-router";
import { Link } from "react-router";
import { Calendar, Home, Activity } from "lucide-react";

export function Header() {
  const { sessionClaims } = useAuth();

  // Check if user is internal based on organization role or metadata
  const publicMetadata = sessionClaims?.publicMetadata as
    | Record<string, any>
    | undefined;
  const isInternal =
    sessionClaims?.org_role === "admin" ||
    publicMetadata?.isInternal === true ||
    sessionClaims?.org_slug === "rb2";

  return (
    <nav className="bg-white border-b border-[#ece4e1]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0 sm:-ml-4">
              <Link to="/">
                <img className="h-8 w-8" src="/logo-light.png" alt="rb2 Logo" />
              </Link>
            </div>
            <div className="ml-10 flex items-baseline space-x-4">
              <OrganizationSwitcher
                hidePersonal={true}
                afterSelectOrganizationUrl="/refresh"
                skipInvitationScreen={true}
                organizationProfileMode="navigation"
                organizationProfileUrl="/org-profile"
              />
            </div>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center space-x-8">
            <SignedIn>
              <div className="flex items-center space-x-6">
                <Link
                  to="/"
                  className="flex items-center gap-2 text-sm font-medium text-[#431908] hover:text-[#fe150a] transition-colors"
                >
                  <Home className="h-4 w-4" />
                  Dashboard
                </Link>
                {isInternal && (
                  <>
                    <Link
                      to="/schedule"
                      className="flex items-center gap-2 text-sm font-medium text-[#431908] hover:text-[#fe150a] transition-colors"
                    >
                      <Calendar className="h-4 w-4" />
                      Schedule
                    </Link>
                    <Link
                      to="/statuspage-internal"
                      className="flex items-center gap-2 text-sm font-medium text-[#431908] hover:text-[#fe150a] transition-colors"
                    >
                      <Activity className="h-4 w-4" />
                      Status
                    </Link>
                  </>
                )}
              </div>
            </SignedIn>
          </div>

          <div className="flex items-center">
            <div className="ml-4 flex items-center md:ml-6">
              <SignedIn>
                <UserButton />
              </SignedIn>
              <SignedOut>
                <span className="text-[#fe150a] px-3 py-2 rounded-[12px] text-sm font-medium">
                  <SignInButton />
                </span>
              </SignedOut>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
